export enum IconType {
  FontAwesome = 'FONT_AWESOME',
  NgZorro = 'NG_ZORRO',
  CustomIcon = 'CUSTOM_ICON',
  Material = 'MATERIAL',
  ImportIcon = 'IMPORT_ICON'
}
